import { Link } from "@tanstack/react-router";
import type { LucideIcon } from "lucide-react";
import type { ComponentProps } from "react";

import { TranslationParams, useTranslation2 } from "~/shared/i18n";
import type { HomeSectionName } from "~/shared/routing";
import { ROUTES, withLocale } from "~/shared/routing";
import { cn } from "~/shared/ui";
import { Button } from "~/shared/ui/button";
import { Card, CardDescription, CardFooter, CardHeader, CardTitle } from "~/shared/ui/card";

type NavigationCardMetadata = {
  Icon: LucideIcon;
  titleT: TranslationParams.Type;
  descriptionT: TranslationParams.Type;
  link: {
    sectionName: HomeSectionName;
    textT: TranslationParams.Type;
  };
};

type Props = ComponentProps<typeof Card> & NavigationCardMetadata;

function NavigationCard({
  Icon,
  titleT,
  descriptionT,
  link: { sectionName, textT },
  className,
  ...props
}: Props) {
  const {
    postproc: { tc },
  } = useTranslation2();

  return (
    <Card className={cn("", className)} {...props}>
      <Icon className="text-secondary size-9 self-center" />
      <CardHeader>
        <CardTitle>{tc(...TranslationParams.toTuple(titleT))}</CardTitle>
        <CardDescription>{tc(...TranslationParams.toTuple(descriptionT))}</CardDescription>
      </CardHeader>
      <CardFooter className="mt-auto justify-center">
        <Button asChild variant="secondary">
          <Link to={withLocale(ROUTES.home)} hash={sectionName}>
            {tc(...TranslationParams.toTuple(textT))}
          </Link>
        </Button>
      </CardFooter>
    </Card>
  );
}

export { NavigationCard };
export type { NavigationCardMetadata };
